<template>
  <div v-if="ready">
    <v-tour
      ref="vtour"
      :name="tour"
      :callbacks="Callbacks" 
      :steps="this[tour+`Steps`]"
      :options="{ highlight: true }"></v-tour>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  name:'AppTour',
  data () {
    return {
      ready: true,
      tour:'overView',
      Callbacks:{
        onFinish: this.doneAction,
        onNextStep: this.customAction,
        onSkip: this.doneAction
      },
      homeViewSteps:[
        {
          target:`#address_group`,
          content:'Step 1 Completing your Home Profile',
        }
      ],
      overViewSteps:[
        {
          offset: -500,
          target: '[data-step="1"]',
          content:'Step 1 Completing your Home Profile',
          params: {
            placement: 'top',
            enableScrolling: true
          }
        },
        {
          offset: -500,
          target: '.col[data-step="2"]:nth-of-type(2)',
          content:`Step 2 you will complete the Wind,`,
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
           {
          offset: -500,
          target: '.col[data-step="2"]:nth-of-type(3)',
          content:` Flood `,
          params: {
            placement: 'top',
            enableScrolling: false
          }
        },
        {
          offset: -500,
          target: '.col[data-step="2"]:nth-of-type(4)',
          content:`And Water Shortage Hazard Assessments`,
          params: {
            placement: 'top',
            enableScrolling: true
          }
        },
        {
          offset: -500,
          target: '.col[data-step="4"]',
          content:`And Water Shortage Hazard Assessments`,
          params: {
            placement: 'top',
            enableScrolling: true
          }
        },
        {
          offset: -500,
          target: '[data-step="1"]',
          content:'Home Profile',
          params: {
            placement: 'top',
            enableScrolling: true
          }
        },
      ]
    }
  },
  computed:{
   ...mapState({
     appTours: state => state.Settings.interface
   })
  },
  watch:{
    'appTours.status': function (nV) {
      if(nV) {
        this.$_startTour(this.appTours.name)
      } else {
        this.$_endTour(this.appTours.name)
      }
    },
    '$route': function(nV){
      if(nV) {
        this.ready = false
        setTimeout(()=> {
          this.ready = true
        },500)     
        if(nV.query && nV.query.start_tour) {
            this.tour = 'homeView'
          setTimeout(() => {
            this.$_startTour('homeView')
          }, 500);
        }
      }
    },
  },
  methods:{
   $_startTour (title) {
     this.tour = title
    setTimeout(() => {
        this.$tours[title].start()
    }, 500);
   },
   $_endTour (title) {
    this.$tours[title].stop()
   },
   customAction(){
 
     if(this.$refs.vtour.currentStep === 4) {
     setTimeout(()=>{
      this.$store.commit('START_VIEW_GUIDE',{
       name:'overView',
       status: false,
     })
    }, 1500)

      setTimeout(() => {
        this.$router.push({
       name:'HomeProfile',
       query:{
         start_tour: true
       }
     })
      }, 2000);
    }
   },
   doneAction () {
      this.$store.commit('START_VIEW_GUIDE', {
        name: this.tour,
        status: false
      })
   }
  }
}
</script>